import request from '@/utils/request'

// 查询列表 通过编号
export function getCityReq() {
  return request({
    url: '/api/user/getCityPc',
    method: 'GET',
  })
}
// 查询选项数据
export function getDictDataReq( query ) {
  return request({
    url: '/api/user/getDictData',
    method: 'GET',
    params: query , //params修改为data
  })
}
